'use strict';

var $ = require('jquery');
var analyticsUtil = require('../../../shared/scripts/modules/utils/analyticsUtil');
var config = require('../../../shared/scripts/modules/utils/globalAnalyticsConfig');

var formStartName = config.GLOBAL_CONFIG.Forms.Events.FormEvents.FORM_START;
var formStepCompleteName = config.GLOBAL_CONFIG.Forms.Events.FormEvents.FORM_STEP_COMPLETE;
var intGroupJoinName = config.GLOBAL_CONFIG.Journeys.INT_GROUP_JOIN;
var startName = config.GLOBAL_CONFIG.Forms.Events.FormStepTypes.START;
var detailsName = config.GLOBAL_CONFIG.Forms.Events.FormStepTypes.DETAILS;

function addAnalyticsHandlers() {

    var pushed = false;

    $('.half').click(function () {
        if(!pushed) {
            pushed = true;
            analyticsUtil.formPush(formStartName, intGroupJoinName, 0, startName);
        }
    });

    $('#next').click(function () {

        analyticsUtil.formPush(formStepCompleteName, intGroupJoinName, 1, detailsName);

    });

}

module.exports.addAnalyticsHandlers = addAnalyticsHandlers;



//////////////////
// WEBPACK FOOTER
// ./src/international/scripts/pages/join-details-start-analytics.js
// module id = eURo
// module chunks = 2 13